// extracted by mini-css-extract-plugin
export default {"icon":"Preloader_icon__kpve1","sm":"Preloader_sm__kB6bq","md":"Preloader_md__LpQBW","lg":"Preloader_lg__G1feX","xl":"Preloader_xl__tMr70","xxl":"Preloader_xxl__D3vgC"};